module.exports = __webpack_public_path__ + "img/excel.5c1aa976.svg";